import { render, staticRenderFns } from "./dialogCreateUserRol.vue?vue&type=template&id=674a5991&scoped=true&"
import script from "./dialogCreateUserRol.vue?vue&type=script&lang=js&"
export * from "./dialogCreateUserRol.vue?vue&type=script&lang=js&"
import style0 from "./dialogCreateUserRol.vue?vue&type=style&index=0&id=674a5991&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a5991",
  null
  
)

component.options.__file = "dialogCreateUserRol.vue"
export default component.exports